import tenantTheme from '@theme';
import tenantRoutes from '@routes';
import tenantConstants from '@constants';
import tenantData from '@data';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Button, Dropdown, Flex, Image, Tag } from '../../../../components/common';
import { useRouteNavigate } from '../../../../hooks';
import { getClassifiedBaseURL } from '../../../../utility/env';
import { NavbarLinks } from './styled';
import { ProfolioLogoLite, ProfolioLogoLiteAr } from '../../../../components/svg';
import { addPropertyEvent } from '../../../../services/analyticsService';
import { getCurrentLocationPath } from '../../../../utility/utility';

const NavBarNavigationContainer = ({ locale, isMobile, fullWidth = false, hidePostAd = false }) => {
  const { t } = useTranslation();
  const pathLocale = locale == 'ar' ? '' : `/${locale}`;
  const user = useSelector((state) => state.app.loginUser.user);
  const navigate = useRouteNavigate();
  const location = useLocation();
  const navItems = useMemo(() => tenantData.getNavbarLinks?.(locale), [locale]);

  return isMobile ? (
    <Flex vertical>
      <a href={`${getClassifiedBaseURL()}/blog${pathLocale}`}>{t('Blog')}</a>
      <Link to={`${pathLocale}/companies`}>{t('Find an Agency')}</Link>
      <Link to={`${pathLocale}/new-projects`}>{t('New Projects')}</Link>
      {/* <Link to={`${pathLocale}/bayut-academy`}>{t('Bayut Academy')}</Link> */}
    </Flex>
  ) : (
    <div className={`navbar-floor ${fullWidth ? 'full-width' : ''}`} style={{'letterSpacing': '0.1px', 'wordSpacing': '-1px'}}>
      <Flex className="container" align="center" justify="space-between" style={{ paddingBlock: '16px' }}>
        <Flex as="a" align="center" href={`${getClassifiedBaseURL()}${pathLocale}`} style={{ marginLeft: '4px' }}>
          {locale === 'en' ? (
            <ProfolioLogoLite
              horizontal={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.horizontal}
              text={tenantConstants?.APP_LOGO?.getLogoText(true)?.[locale]}
              width={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.width}
              height={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.height}
            />
          ) : (
            <ProfolioLogoLiteAr
              horizontal={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.horizontal}
              text={tenantConstants?.APP_LOGO?.getLogoText(true)?.[locale]}
              width={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.width}
              height={tenantConstants?.APP_LOGO?.getLogoTextPlacement(true)?.[locale]?.height}
            />
          )}
        </Flex>
        <NavbarLinks align="center" gap="18px">
          {!!navItems?.length &&
            navItems?.map((item, i) => {
              if (item.dropdown) {
                return (
                  <Dropdown
                    key={i}
                    options={item.dropdown}
                    placement={locale === 'ar' ? 'bottomLeft' : 'bottomRight'}
                    getOptionLabel={(e) => t(e.title)}
                    getOptionLink={(e) => e.href}
                    useAsLink={true}
                    rootClassName="p-0"
                    className="navbar-text"
                    suffixIcon="IoMdArrowDropdown"
                    suffixIconProps={{ size: '0.875em', color: '#4c4a4a' }}
                    style={{ gap: 0 }}
                    dropdownItemStyle={{ padding: '0', margin: '1px 0px 0px -10px' }}
                    overlayStyle={{
                      maxWidth: '160px',
                      maxHeight: '100px',
                      overflow: 'hidden',
                      borderRadius: '5px',
                      border: '0.5px solid #dedede'
                    }}

                  >
                    <span style={{ position: 'relative', top: '1px', color: '#222222', marginRight: '-2px' }}>{t(item.title)}</span>
                  </Dropdown>
                );
              }
              return (
                <a
                  key={i}
                  href={item.href}
                  style={{
                    ...(item.imgSrc ? { marginRight: '5px' } : {marginBottom: '2px', marginRight: '4px'}),
                    ...(item?.showNewTag ? { marginTop: '3px', marginRight: '-1px' } : {}),
                  }}
                >
                  {item.imgSrc && <Image src={item.imgSrc} style={{ ...item?.imgProps }} />}
                  {t(item.title)}
                  {item?.showNewTag && (
                    <Tag
                      color={tenantTheme['danger-color']}
                      style={{
                        '--tag-color': '#fff',
                        '--tag-font-size': '10px',
                        padding: '3px 5px',
                        borderRadius: '16px',
                        fontWeight: 600,
                        insetInlineStart: '3px',
                        insetBlockStart: '-7px',
                      }}
                    >
                      {t('NEW')}
                    </Tag>
                  )}
                </a>
              );
            })}

          {!hidePostAd && <Button
            type="success"
            icon="IconPostListing"
            style={{  top: '-3px', fontWeight: 700, paddingTop: '15px', padding: '18.5px 11px', gap: '7px' }}
            onClick={() => {
              addPropertyEvent(user, getCurrentLocationPath(location), false);
              navigate(tenantRoutes.app('', false, user).post_listing.path);
            }}
          >
            <span style={{ marginBottom: '1px' }}>
              {t('Post a Listing')}
            </span>
          </Button>}
        </NavbarLinks>
      </Flex>
    </div>
  );
};

export default NavBarNavigationContainer;
